var map = {
	"./back.svg": "vXXF",
	"./clipboard.svg": "hbSd",
	"./clipboardhover.svg": "H7X9",
	"./contacts.svg": "KQqE",
	"./edit.svg": "GJ1R",
	"./eye.svg": "bDKe",
	"./happy.svg": "BdRl",
	"./list-alt.svg": "1yVm",
	"./list.svg": "DwRn",
	"./nav_icon.svg": "MQgp",
	"./qq.svg": "2qhd",
	"./save.svg": "0Eth",
	"./shop-icon.svg": "LFij"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "SnOs";


//////////////////
// WEBPACK FOOTER
// ./src/icon/svg nonrecursive \.svg$
// module id = SnOs
// module chunks = 24